import { h, Component } from 'preact';
import { Link } from 'preact-router';
import { LoadingInline } from 'lib/mkjs';
import { TOWNSHEND_LINKS } from 'lib/townshend/components/townshendentities';
import {
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem } from 'reactstrap';
import style from './style.less';

export default class Header extends Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.handleScroll = this.handleScroll.bind(this);

		this.state = {};
		this.componentWillReceiveProps(props);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll(event) {
		const isScrolled = window.scrollY > 0;
		if (isScrolled != this.state.isScrolled) {
			this.setState({
				isScrolled
			})
		}
	}

	componentWillReceiveProps(nextProps, nextState) {
		this.setState({
			usermenu: false,
			hamburger: false,
		});
	}

	toggle(key) {
		this.setState({
			[key]: !this.state[key]
		});
	}

	handleLogout() {
		this.props.apis.user.logout()
		.then(response => {
			this.props.onLogout();
		}).catch(error => {
			console.error('error logging in. TODO show error',error);
		});
	}

	getDropdownItems() {
		if (this.props.isAuthenticated) {
			//TODO get admin or non-admin
			let items = [
				<DropdownItem tag="a" href={ "/me" }>
					My Contact Info
				</DropdownItem>
			];
			if (this.props.userIsAdmin) {
				let applicationItems = Object.keys(this.props.entities).map(path=>{
					let e = new this.props.entities[path]().getDisplayName();
					return <DropdownItem tag="a" href={ "/" + path }>{e}</DropdownItem>
				})
				items = items.concat([
					<DropdownItem divider />,
					applicationItems,
					<DropdownItem divider />,
					TOWNSHEND_LINKS.map(l=><DropdownItem tag="a" href={ "/" + l.path }>
						{l.name}
					</DropdownItem>),
				]);
			}
			items = items.concat([
				<DropdownItem divider />,
				<DropdownItem tag="a" href="/auth/my-account" >
					My Addy Account
				</DropdownItem>,
				<DropdownItem onClick={this.handleLogout}>
					Log Out
				</DropdownItem>
			])
			return items;
		} else {
			return []
		}
	}

	getUserNav() {
		let classes = [style.nav_dropdown, style.narrow_include, style.vcenter, "mx-3", "mr-lg-5"].join(' ');
		if (this.props.isAuthenticated) {
			let ddItems = this.getDropdownItems();
			return <Dropdown nav inNavbar className={classes} isOpen={this.state.usermenu} toggle={()=>this.toggle('usermenu')}>
				<DropdownToggle nav>
					<i class="fa fa-bars" aria-hidden="true"></i>{/*TODO add headshot*/}
				</DropdownToggle>
				<div tabindex="-1" role="menu" aria-hidden="true" class={"dropdown-menu dropdown-menu-right" + (this.state.usermenu ? " show" : "")}>
					{ ddItems }
				</div>
			</Dropdown>
		} else if (this.props.isLoading) {
			return <NavItem className={classes}><Link className="nav-link"><LoadingInline /></Link></NavItem>
		} else {
			return <NavItem className={classes}>
				<div>
					<Link href="/auth/login" className={"btn btn-link font-weight-bold " + style.color_black + " " + style.btn_responsive}>Sign in</Link>
					<Link href="/join" className={"btn btn-mkjs-primary " + style.btn_responsive}>GET STARTED</Link>
				</div>
			</NavItem>
		}
	}

	render(props) {
		let brandName = this.props.env == 'development' ? 'Addy.dev' : 'Addy';
		let navPositionClass = style[this.state.isScrolled ? "nav_container_scrolled" : "nav_container_unscrolled"]
		return (
			<div class={[style.nav_container,navPositionClass,"sticky-top"].join(' ')}>
				<Navbar expand="xs" className={ style.addy + " text-nowrap" }>
					<NavbarBrand className={style.navbar_title} href={"/"}>{brandName}<sup><i> beta</i></sup></NavbarBrand>
					<Nav navbar>
						{ this.getUserNav() }
					</Nav>
				</Navbar>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js